import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { UseFormResetField } from 'react-hook-form/dist/types/form';

import {
	DefaultOptionsInterface,
} from '@components/common';

import { generateDefaultValues } from '@components/Kpi/Parameters/utils';

import { IGroupSelectOptions } from '@components/common/GroupSelect/GroupSelect.types';

import { EFormFields } from '@enums/kpi-api';

export const useTechnologySelectorsLogic = ({
	setIsDirty,
	setValue,
	resetField,
}: {
	setIsDirty: Dispatch<SetStateAction<boolean>>;
	setValue:  UseFormSetValue<FieldValues>;
	resetField: UseFormResetField<FieldValues>;
}) => {
	const [defaultValueT_4G_FDD, setDefaultValueT_4G_FDD] = useState<DefaultOptionsInterface[]>([]);
	const [defaultValueT_4G_TDD, setDefaultValueT_4G_TDD] = useState<DefaultOptionsInterface[]>([]);
	const [defaultValueT_5G, setDefaultValueT_5G] = useState<DefaultOptionsInterface[]>([]);

	const onChangeSitesT_4G_FDD = useCallback((
		values: IGroupSelectOptions[],
		isUpdateDirty: boolean = true,
	) => {
		setValue(EFormFields.sitesT_4G_FDD, values);
		setDefaultValueT_4G_FDD(generateDefaultValues(values));

		setIsDirty(isUpdateDirty);
	}, [setIsDirty, setValue]);

	const onChangeSitesT_4G_TDD = useCallback((
		values: IGroupSelectOptions[],
		isUpdateDirty: boolean = true,
	) => {
		setValue(EFormFields.sitesT_4G_TDD, values);
		setDefaultValueT_4G_TDD(generateDefaultValues(values));

		setIsDirty(isUpdateDirty);
	}, [setIsDirty, setValue]);

	const onChangeSitesT_5G = useCallback((
		values: IGroupSelectOptions[],
		isUpdateDirty: boolean = true,
	) => {
		setValue(EFormFields.sitesT_5G, values);
		setDefaultValueT_5G(generateDefaultValues(values));

		setIsDirty(isUpdateDirty);
	}, [setIsDirty, setValue]);

	const resetT_4G_FDD = useCallback(() => {
		setDefaultValueT_4G_FDD([]);
		resetField(EFormFields.sitesT_4G_FDD);
	}, [resetField]);

	const resetT_4G_TDD = useCallback(() => {
		setDefaultValueT_4G_TDD([]);
		resetField(EFormFields.sitesT_4G_TDD);
	}, [resetField]);

	const resetT_5G = useCallback(() => {
		setDefaultValueT_5G([]);
		resetField(EFormFields.sitesT_5G);
	}, [resetField]);

	return {
		defaultValueT_4G_FDD,
		defaultValueT_4G_TDD,
		defaultValueT_5G,
		onChangeSitesT_4G_FDD,
		onChangeSitesT_4G_TDD,
		onChangeSitesT_5G,
		resetT_4G_FDD,
		resetT_4G_TDD,
		resetT_5G,
		setDefaultValueT_4G_FDD,
		setDefaultValueT_4G_TDD,
		setDefaultValueT_5G,
	};
};
